<div class="wrapper-container">
  <!-- <div
    class="flexible-country-container"
    [ngClass]="{ active: isExpanded }"
    (click)="toggleContent()"
    #containerWrapper
  >
    <div class="inner-country-container" [ngClass]="{ active: isExpanded }">
      <div class="country-body">
        <div class="flow-container">
         <ng-container *ngIf="flow === 'deposit'; else withdraw">
          <span class="funds-flow-header">{{sdfCardLabels?.landingPage?.cashInCountry}} </span>
         </ng-container>
         <ng-template #withdraw>
          <span class="funds-flow-header">{{sdfCardLabels?.landingPage?.cashOutCountry}} </span>
         </ng-template>
        </div>
        <div class="flag-and-country-name" [ngClass]="{ active: isExpanded }">
          <img [src]="flagSrc" alt="" class="flag" width="24" loading="lazy" *ngIf="selectedCountryName" />
          <div class="country-name-container">
            <span class="country-label-text">
              {{ selectedCountryName }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="icon-container" [ngClass]="{ active: isExpanded }">
      <img
        class="icon"
        [ngClass]="{ active: isExpanded }"
        src="assets\images\arr.chevron.down.small.svg"
        alt=""
      />
    </div>
  </div> -->
  <div
    class="flex-country-wrapper"
    [ngClass]="{ active: (isExpanded$ | async) }"
    (click)="toggleContent()"
    #containerWrapper
  >
    <div class="country-body" [ngClass]="{ active: (isExpanded$ | async) }">
      <div class="country-or-province-label-container">
        <!-- Update state or province withd data from CMS -->
        <ng-container *ngIf="flow === 'deposit'; else withdraw">
          <span class="country-or-province-label-text"
            >{{ sdfCardLabels?.landingPage?.cashInCountry }}
          </span>
        </ng-container>
        <ng-template #withdraw>
          <span class="country-or-province-label-text">{{
            sdfCardLabels?.landingPage?.cashOutCountry
          }}</span>
        </ng-template>
      </div>
      <ng-container>
        <div
          class="country-name-container"
          [ngClass]="{ active: (isExpanded$ | async) }"
        >
          <img
            [src]="flagSrc"
            alt=""
            class="flag"
            width="24"
            loading="lazy"
            *ngIf="countryName"
          />
          <div
            *ngIf="countryName; else selectCountrylabel"
            class="country-name-label-text"
            [ngClass]="{ active: (isExpanded$ | async) }"
          >
            {{ countryName }}
          </div>
          <ng-template #selectCountrylabel>
            <div  class="country-name-label-text"  [ngClass]="{ active: (isExpanded$ | async) }">
              {{  sdfCardLabels?.common?.selectCountry ||  'Select country'}}
            </div>
          </ng-template>
          <!-- <span *ngIf="!selectedCountryName" class="country-name-label-text" [ngClass]="{ active: isExpanded }">Select
            country</span> -->
        </div>
      </ng-container>
    </div>
    <div class="icon-body" [ngClass]="{ active: (isExpanded$ | async) }">
      <img
        class="icon"
        [ngClass]="{ active: (isExpanded$ | async) }"
        src="assets\images\arr.chevron.down.small.svg"
        alt=""
      />
    </div>
  </div>

  <div class="webWrapper-absolute">
    <div
      class="divider"
      [ngClass]="{
        active: (isExpanded$ | async) && (isMobile$ | async) === false
      }"
    ></div>

    <div
      class="web-content-container"
      (click)="$event.stopPropagation()"
      [@dropdown]
      *ngIf="
        (isExpanded$ | async) && (isMobile$ | async) === false;
        else mobileView
      "
      [style.height]="dropdownHeight"
      [ngClass]="{ active: (isExpanded$ | async) }"
    >
      <div class="selective-card-menu">
        <div class="list-menu-container">
          <div class="input-search-filled">
            <img
              src="assets\images\form-iOS-search-filled.svg"
              alt=""
              class="search-icon"
            />
            <input
              type="text"
              class="input"
              [placeholder]="
                sdfCardLabels?.landingPage?.searchForCountryPlaceholder
              "
              [formControl]="countryControl"
              (input)="isUserTyping = true"
            />
            <img
              src="assets\images\remove-circle.svg"
              alt=""
              class="xtimes"
              *ngIf="countryControl.value!"
              (click)="onResetForm()"
              [@fadeInOut]
            />
          </div>
        </div>
      </div>
      <div class="country-drop-container">
        <div
          class="list-menu-container"
          [ngStyle]="{ padding: isUserTyping ? '0' : null }"
        >
          <ng-container *ngIf="!isUserTyping && countryControl.value!">
            <span class="country-selected-label">
              {{ sdfCardLabels?.landingPage?.countrySelected }}
            </span>
            <div class="country-selected-container">
              <div class="country-info-container">
                <!-- <img
                  src="/assets/images/flag-placeholder.svg"
                  alt=""
                  class="flag"
                /> -->
                <img
                  [src]="flagSrc"
                  alt=""
                  class="flag"
                  width="24"
                  loading="lazy"
                  *ngIf="countryName"
                />
                <span class="country-name">{{ countryName }}</span>
                <img
                  src="assets/images/checked-circle.svg"
                  alt=""
                  class="check-mark-icon"
                />
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!isUserTyping && countryControl.value!">
            <span class="all-countries-label">
              {{ sdfCardLabels?.landingPage?.allCountries }}
            </span>
          </ng-container>
          <ul
            class="countries-with-flags-container"
            *ngIf="filteredCountries$ | async as filteredCountries"
          >
            <li
              class="country-details"
              (click)="setDefaultCountryStatePair(country.name)"
              *ngFor="let country of filteredCountries; let i = index"
              [class.active]="i === activeIndex"
            >
              <img
                [src]="getFlagUrls(country.name)"
                alt=""
                width="24"
                class="flag"
                loading="lazy"
              />

              <span class="country-name">
                {{ country.name }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <ng-template #mobileView>
    <div
      class="mobile-content-container"
      [@slideInOutAnimation]="(isExpanded$ | async) ? 'in' : 'out'"
      class="mobile-content-container"
      (click)="$event.stopPropagation()"
      *ngIf="(isExpanded$ | async) && (isMobile$ | async)"
    >
      <div class="topBar_iOS_newTitle">
        <div class="top-bar">
          <div class="form_iOS_search_filled">
            <img
              src="assets\images\form-iOS-search-filled.svg"
              alt=""
              class="search-icon"
            />
            <input
              type="text"
              placeholder="Search for country"
              class="country-input"
              placeholder="Search for country"
              [formControl]="countryControl"
              (input)="isUserTyping = true"
            />
            <img
              src="assets\images\remove-circle.svg"
              alt=""
              class="xtimes"
              *ngIf="countryControl.value!"
              (click)="onResetForm()"
              [@fadeInOut]
            />
          </div>
          <div class="close-icon">
            <img
              src="/assets/images/close-icon.svg"
              alt=""
              class="close"
              (click)="closeDrawer()"
            />
          </div>
        </div>
      </div>
      <div class="country-selected-and-all-countries-mobile-wrapper">
        <div class="country-selected-and-all-countries-mobile">
          <ng-container *ngIf="displayCountrySelContent()">
            <div class="country-selected-container">
              <div class="selected-country-label-text">
                {{ sdfCardLabels?.landingPage?.countrySelected }}
              </div>
            </div>
            <div class="all-countries-header-container">
              <div class="all-countries-label-text">
                {{ sdfCardLabels?.landingPage?.allCountries }}
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="filteredCountries$ | async as filteredCountries">
            <div class="frame-2608167">
              <div
                class="frame-12659"
                *ngFor="let country of filteredCountries; let i = index"
                [class.active]="i === activeIndex"
                (click)="setDefaultCountryStatePair(country.name)"
              >
                <div class="flag-container">
                  <img
                    [src]="getFlagUrls(country.name)"
                    alt=""
                    width="24"
                    class="flag"
                    loading="lazy"
                  />
                </div>
                <div class="mxn">
                  {{ country.name }}
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <ng-container *ngIf="!isUserTyping && countryControl.value!">
          <div class="rectangle-4956">
            <div class="selected-country-container">
              <div class="flag-container">
                <!-- <img
              src="/assets/images/flag-placeholder.svg"
              alt=""
              class="flag"
            /> -->
                <img
                  [src]="flagSrc"
                  alt=""
                  class="flag"
                  width="24"
                  loading="lazy"
                  *ngIf="countryName"
                />
              </div>
              <span class="country-name">{{ countryName }}</span>
              <img
                src="assets/images/checked-circle.svg"
                alt=""
                class="check-mark-icon"
              />
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-template>

  <ng-container *ngIf="(isExpanded$ | async) && (isMobile$ | async)">
    <div
      class="overlay"
      (click)="$event.stopPropagation()"
      [@overlayFadeInOutAnimation]
      [ngClass]="{ active: (isExpanded$ | async) && (isMobile$ | async) }"
    ></div>
  </ng-container>
</div>
